/* ig-pdp-option-chips.js  v4  2026-08-27
   Product page: replace the Jewelry material / Carat Weight dropdowns with
   tappable chips, matching the collection card (Larry, 27 Aug).

   The <select> is NOT removed and NOT replaced. It stays the source of truth:
   a chip writes select.value and fires a bubbling change event, so the theme's
   variant-selects element swaps the variant, price and images exactly as it
   already does. Anything else listening to that select keeps working too -
   including the sticky add-to-cart bar.

   Chips are DISPLAYED in ascending numeric order (1, 1.5, 2, 3, 4, 5) while
   the select keeps its own order, which puts the photographed variant first.
   Same split as the collection cards: sorted to read, default to select.

   Chips also re-sync FROM the select, so a variant changed by any other route
   still shows the right chip pressed.

   v3: the seven rings that go past 5ct carry "6.0ct or above ( Contact Us )".
   That string is far too long for a 44px chip, so shortLabel() renders it as
   "6+". The full text stays on the chip's title/aria-label, in the option label
   suffix and in the sticky bar.

   v4: DESKTOP TOO. Larry, 27 Aug: "the website should mirror the changes ...
   how we can click the carat size and material on product page". The
   max-width:768px gate is gone here and in the .css; the same chips now render
   at every width. The <select> still does the work, so nothing about desktop
   variant behaviour changes - only how the choice is presented.

   Product template, all widths. Revert notes in the .css. */
(function () {
  'use strict';

  var COLOUR = {
    'white gold': '#E9E9E7',
    'yellow gold': '#E4C06A',
    'rose gold': '#E3B39F',
    'platinum': '#D9DADE'
  };
  var RE_METAL = /^(?:(14K|18K)\s+)?(White Gold|Yellow Gold|Rose Gold|Platinum)$/i;
  var RE_NUM = /(\d+(?:\.\d+)?)/;
  var RE_ENQUIRE = /or above|contact/i;

  function isMetalOption(select) {
    if (/material|metal/i.test(select.name || '')) return true;
    for (var i = 0; i < select.options.length; i++) {
      if (!RE_METAL.test(select.options[i].text.trim())) return false;
    }
    return select.options.length > 0;
  }

  /* 3.0ct -> 3, 1.5ct -> 1.5, 15.5CM -> 15.5, EU 52 -> EU 52, Yes -> Yes.
     "6.0ct or above ( Contact Us )" -> 6+.
     The label above already carries the unit, same as on the cards. */
  function shortLabel(v) {
    if (RE_ENQUIRE.test(v)) {
      var e = v.match(RE_NUM);
      return (e ? String(parseFloat(e[1])) : '') + '+';
    }
    if (/^\d+(\.\d+)?\s*(ct|tcw|cm)$/i.test(v)) {
      var n = parseFloat(v);
      if (!isNaN(n)) return String(n);
    }
    return v;
  }

  function karat(v) {
    var m = v.match(RE_METAL);
    if (!m) return '';
    return m[1] ? m[1].toUpperCase() : 'PT';
  }

  /* ascending when every value carries a number, otherwise leave DOM order */
  function displayOrder(values) {
    for (var i = 0; i < values.length; i++) {
      if (!RE_NUM.test(values[i])) return values.slice();
    }
    return values.slice().sort(function (a, b) {
      return parseFloat(a.match(RE_NUM)[1]) - parseFloat(b.match(RE_NUM)[1]);
    });
  }

  function buildFor(select) {
    if (select.getAttribute('data-ig-chips') === '1') return;
    var field = select.closest('.product-form__inpt');
    var wrap = select.closest('.select');
    if (!field || !wrap) return;
    if (select.options.length < 2) return;
    select.setAttribute('data-ig-chips', '1');

    var metal = isMetalOption(select);
    var values = [];
    for (var i = 0; i < select.options.length; i++) values.push(select.options[i].text.trim());
    var ordered = metal ? values : displayOrder(values);

    var row = document.createElement('div');
    row.className = 'ig-opt';

    var label = field.querySelector('.form__label');
    var current = null;
    if (label) {
      current = document.createElement('span');
      current.className = 'ig-opt__current';
      label.appendChild(current);
    }

    var buttons = [];

    ordered.forEach(function (value) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-v', value);
      b.title = value;
      b.setAttribute('aria-label', value);

      if (metal) {
        var m = value.match(RE_METAL);
        var fam = (m && m[2] ? m[2] : '').toLowerCase();
        b.className = 'ig-opt__metal';
        b.style.background = COLOUR[fam] || '#DDD';
        b.textContent = karat(value);
      } else {
        b.className = 'ig-opt__val';
        b.textContent = shortLabel(value);
      }

      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (select.value === value) return;
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });

      buttons.push(b);
      row.appendChild(b);
    });

    function sync() {
      for (var k = 0; k < buttons.length; k++) {
        buttons[k].setAttribute('aria-pressed', String(buttons[k].getAttribute('data-v') === select.value));
      }
      if (current) current.textContent = select.value ? '— ' + select.value : '';
    }

    select.addEventListener('change', sync);
    wrap.parentNode.insertBefore(row, wrap.nextSibling);
    wrap.classList.add('ig-chips-hidden');
    sync();
  }

  function run() {
    var selects = document.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].closest('.product-form__inpt')) buildFor(selects[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
}());
